/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI'
], (APIFactory, PropertiesProviderAPI) => {

	class DashboardInternalProperties {
		constructor({ features, options }) {
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			this._templateCollection = options.templateCollection || [];
			features['Properties'].registerProvider(this.getAPI());
		}
		getAPI() {
			return this._api;
		}
		getPropertyLayoutList() { return []; }
		getPropertyList() {
			return [{
				id: 'excludedTemplates',
				getPropertyValue: () => {
					return this._getExcludedTemplatesFromCollections();
				},
				setPropertyValue: () => { throw new Error('not supported');}
			}];
		}
		reset() { }
		_getExcludedTemplatesFromCollections() {
			let excludedTemplates = [];
			this._templateCollection.find(template => {
				if (template.dataId === 'tab' && Array.isArray(template.excludedTemplates)) {
					excludedTemplates = excludedTemplates.concat(template.excludedTemplates);
				}
			});
			return excludedTemplates;
		}
	}

	return DashboardInternalProperties;
});